
import React, { useEffect, useRef } from "react";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from "react-redux";

export default function DropDownForDayNight(props) {
  const { recurrenceRule } = useSelector((state) => state.createOrderSlice);



  const { label, options, recurrenceRuleSet, selectedDays,selectedService,error } = props;

    // const prevDaysRef = useRef(recurrenceRule.days);
  
    // useEffect(() => {
    //   if (JSON.stringify(prevDaysRef.current) !== JSON.stringify(recurrenceRule.days)) {
    //     prevDaysRef.current = recurrenceRule.days; 
    //     recurrenceRuleSet({timePreference: null, timePreferenceObject: null})
    //   }
    // }, [recurrenceRule.days]);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          onChange={(e) => recurrenceRuleSet({ timePreference: e.target.value.value, timePreferenceObject: e.target.value })}
          disabled={!selectedDays?.length}
          value={recurrenceRule?.timePreferenceObject ? recurrenceRule?.timePreferenceObject : ""}
        >
          {options.map((item) => {
            return (
              <MenuItem value={item}>{item.option}</MenuItem>
            )

          })}

        </Select>
        {error ? !recurrenceRule?.timePreferenceObject && <p className='form-error-message'>This field is required</p> :null}
      </FormControl>
    </Box>
  );


}


